var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { syntheticEvent } from '../../components/helpers';
export function positionStyle(node, width, height) {
    return "\n    position: absolute;\n    left: ".concat(node.x, "px;\n    top: ").concat(node.y, "px;\n    width: ").concat(width, "px;\n    height: ").concat(height, "px;\n    opacity: ").concat(node.opacity, ";\n    pointer-events: ").concat(node.listening ? 'auto' : 'none', ";\n  ");
}
export function getState(node) {
    var _a, _b;
    return ((_b = (_a = node.metadata) === null || _a === void 0 ? void 0 : _a.componentState) !== null && _b !== void 0 ? _b : {});
}
export function modifierClasses(base, mods, extra) {
    var _a;
    if (extra === void 0) { extra = ''; }
    var bases = base.split(' ').filter(Boolean);
    var root = (_a = bases[0]) !== null && _a !== void 0 ? _a : base;
    var parts = __spreadArray([], __read(bases), false);
    if (mods.size && mods.size !== 'md')
        parts.push("".concat(root, "--").concat(mods.size));
    if (mods.invalid)
        parts.push("".concat(root, "--invalid"));
    if (mods.disabled)
        parts.push("".concat(root, "--disabled"));
    if (mods.fullWidth)
        parts.push("".concat(root, "--full"));
    if (extra)
        parts.push(extra);
    return parts.filter(Boolean).join(' ');
}
export function fieldWidth(state, fallback) {
    var _a;
    if (state.fullWidth)
        return '100%';
    return Number((_a = state.width) !== null && _a !== void 0 ? _a : fallback);
}
export function syncFieldError(wrap, error) {
    var errEl = wrap.querySelector('.lightdraw-field-error');
    if (error) {
        if (!errEl) {
            errEl = document.createElement('span');
            errEl.className = 'lightdraw-field-error';
            errEl.setAttribute('role', 'alert');
            wrap.appendChild(errEl);
        }
        errEl.textContent = error;
    }
    else if (errEl) {
        errEl.remove();
    }
}
export function escHtml(s) {
    return s
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}
export function formatTableCell(cell) {
    var lower = cell.toLowerCase();
    if (lower === 'active' || lower === 'done' || lower === 'success') {
        return "<span class=\"lightdraw-badge lightdraw-badge--success\">".concat(escHtml(cell), "</span>");
    }
    if (lower === 'beta' || lower === 'pending' || lower === 'warning') {
        return "<span class=\"lightdraw-badge lightdraw-badge--warning\">".concat(escHtml(cell), "</span>");
    }
    if (lower === 'error' || lower === 'failed' || lower === 'inactive') {
        return "<span class=\"lightdraw-badge lightdraw-badge--danger\">".concat(escHtml(cell), "</span>");
    }
    return escHtml(cell);
}
export function sortTableRows(rows, col, dir) {
    return __spreadArray([], __read(rows), false).sort(function (a, b) {
        var _a, _b;
        var av = (_a = a[col]) !== null && _a !== void 0 ? _a : '';
        var bv = (_b = b[col]) !== null && _b !== void 0 ? _b : '';
        var cmp = av.localeCompare(bv, undefined, { numeric: true, sensitivity: 'base' });
        return dir === 'asc' ? cmp : -cmp;
    });
}
export function filterTableRows(rows, query) {
    var q = query.trim().toLowerCase();
    if (!q)
        return rows;
    return rows.filter(function (row) { return row.some(function (cell) { return String(cell).toLowerCase().includes(q); }); });
}
export function absPosition(node, width, height) {
    var w = width !== undefined ? "width: ".concat(typeof width === 'number' ? "".concat(width, "px") : width, ";") : '';
    var h = height !== undefined ? "height: ".concat(typeof height === 'number' ? "".concat(height, "px") : height, ";") : '';
    return "\n    position: absolute;\n    left: ".concat(node.x, "px;\n    top: ").concat(node.y, "px;\n    ").concat(w, "\n    ").concat(h, "\n    opacity: ").concat(node.opacity, ";\n    pointer-events: ").concat(node.listening ? 'auto' : 'none', ";\n  ");
}
export function bindDelegated(el, handler) {
    if (el.dataset.ldDelegated === '1')
        return;
    el.dataset.ldDelegated = '1';
    el.addEventListener('click', handler);
}
export var dialogTrapHandlers = new WeakMap();
export var menuOutsideHandlers = new WeakMap();
export var tooltipDelayTimers = new Map();
export function trapDialogFocus(host) {
    var dialog = host.querySelector('.lightdraw-dialog');
    if (!dialog)
        return;
    var focusable = dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (focusable.length === 0)
        return;
    focusable[0].focus();
    var existing = dialogTrapHandlers.get(host);
    if (existing)
        host.removeEventListener('keydown', existing);
    var handler = function (e) {
        if (e.key !== 'Tab')
            return;
        var list = Array.from(focusable);
        var first = list[0];
        var last = list[list.length - 1];
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        }
        else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    };
    dialogTrapHandlers.set(host, handler);
    host.addEventListener('keydown', handler);
}
export function releaseDialogFocus(host) {
    var existing = dialogTrapHandlers.get(host);
    if (existing) {
        host.removeEventListener('keydown', existing);
        dialogTrapHandlers.delete(host);
    }
}
export function bindMenuOutsideClose(el, node) {
    var existing = menuOutsideHandlers.get(el);
    if (existing)
        document.removeEventListener('mousedown', existing);
    var handler = function (e) {
        var _a;
        var target = e.target;
        if (target instanceof globalThis.Node && el.contains(target))
            return;
        node.metadata.componentState = __assign(__assign({}, getState(node)), { open: false });
        node.visible = false;
        node.emit('close', syntheticEvent('close', node));
        (_a = node.getApp()) === null || _a === void 0 ? void 0 : _a.requestRender();
        document.removeEventListener('mousedown', handler);
        menuOutsideHandlers.delete(el);
    };
    menuOutsideHandlers.set(el, handler);
    setTimeout(function () { return document.addEventListener('mousedown', handler); }, 0);
}
export function isDangerMenuItem(item, variants, index) {
    if ((variants === null || variants === void 0 ? void 0 : variants[index]) === 'danger')
        return true;
    var lower = item.toLowerCase();
    return lower === 'delete' || lower === 'remove' || lower === 'danger';
}
export function scheduleTooltipShow(node, delayMs, show) {
    var prev = tooltipDelayTimers.get(node.id);
    if (prev !== undefined)
        clearTimeout(prev);
    if (delayMs <= 0) {
        show();
        return;
    }
    var id = window.setTimeout(show, delayMs);
    tooltipDelayTimers.set(node.id, id);
}
export function cancelTooltipShow(nodeId) {
    var prev = tooltipDelayTimers.get(nodeId);
    if (prev !== undefined) {
        clearTimeout(prev);
        tooltipDelayTimers.delete(nodeId);
    }
}
